import config, { colors } from './config';

export const getColor = areaKey => {
  return config[areaKey].color;
};

export const getIconType = segmentName => `car_${segmentName.toLowerCase()}`;

export const getFontColor = color => {
  const colorIndex = colors.indexOf(color);
  return colorIndex < 6 ? 'rgba(0,0,0,.65)' : 'rgba(255,255,255,.8)';
};
